var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "20px",
    viewBox: "0 0 6 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Farmacovigilancia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FarmacoV_1_Web",
    transform: "translate(-1602.000000, -2108.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -41,
    y: 1009,
    width: 2067,
    height: 1373
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1604.000000, 2161.000000) rotate(-90.000000) translate(-1604.000000, -2161.000000) translate(1551.000000, 2153.000000)",
    fill: "#EE3B42",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.650753,8.3145408 L102.630779,6.15429575 C102.083597,5.76293241 101.327322,6.16145517 101.327322,6.84003456 L101.327322,8.16128433 L86.8269469,8.16128433 C86.3702822,8.16128433 86,8.53693049 86,9.00033555 C86,9.46374061 86.3702822,9.83933083 86.8269469,9.83933083 L101.327212,9.83933083 L101.327212,11.1605247 C101.327212,11.8435787 102.087511,12.2346624 102.630614,11.8462635 L105.650588,9.68601843 C106.111773,9.35634921 106.121089,8.65170504 105.650753,8.3145408 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.37b9dfe124b7ef062acb4f784d0563ee.svg";
export { ForwardRef as ReactComponent };